<template>
      <v-container class="vacanyFilter">
        <v-row>
          <v-col cols="12" md="10">
              <v-row>
                <v-col cols="12" sm="9" md="6"
                class="text-none py-2"
                >
                  <v-text-field
                    v-model="filters.title"
                    :label="$t('vacancies.filters.jobTitle', 'Functietitel')"
                    clearable
                    variant="solo"
                    hide-details="auto"
                    flat
                    class="pa-0"
                    @keyup.enter="search"
                  />
                </v-col>
                <v-col cols="12" sm="9" md="6"
                class="text-none py-2"
                >
                  <v-text-field
                    v-model="filters.city"
                    :label="$t('vacancies.filters.workCity', 'Werkstad')"
                    clearable
                    variant="solo"
                    hide-details="auto"
                    flat
                    class="pa-0"
                    @keyup.enter="search"
                  />
                </v-col>
              </v-row>
            </v-col>
          <v-col cols="12" md="2"
          class="text-none py-2"
          >
                <v-btn 
                  color="primary" 
                  block 
                  @click="search"
                  class="text-none py-4 py-sm-7"
                >
                  {{ $t('vacancies.filters.search', 'Zoeken') }}
                </v-btn>

          </v-col>
        </v-row>
      </v-container>
</template>

<script setup>
const router = useRouter()
const route = useRoute()
const { t } = useI18n()

const filters = reactive({
  title: route.query.title || '',
  companyName: route.query.companyName || '',
  city: route.query.city || ''
})

const search = () => {
  const query = {}
  Object.keys(filters).forEach(key => {
    if (filters[key]) query[key] = filters[key]
  })
  router.replace({ query })
}

const clearFilters = () => {
  Object.keys(filters).forEach(key => {
    filters[key] = ''
  })
  router.replace({ query: {} })
}
</script>
